import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "inline-flex items-center mr-3" }
const _hoisted_3 = {
  key: 1,
  class: "inline-flex rounded-full p-2.5"
}
const _hoisted_4 = { class: "font-medium text-gray-800 truncate" }
const _hoisted_5 = { class: "w-6.5 pr-4 flex justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpandIcon = _resolveComponent("ExpandIcon")!
  const _component_CustomCheckbox = _resolveComponent("CustomCheckbox")!
  const _component_ContentOptionsNode = _resolveComponent("ContentOptionsNode", true)!
  const _component_ExpandCollapseTransition = _resolveComponent("ExpandCollapseTransition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex items-center w-full h-12 cursor-pointer hover:bg-gray-100 transition-colors', _ctx.showBottomBorder ? 'border-b border-gray-200' : '']),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleOption && _ctx.onToggleOption(...args)))
    }, [
      _createElementVNode("span", {
        class: "flex-1 flex items-center truncate",
        style: _normalizeStyle(_ctx.indentStyle)
      }, [
        _createElementVNode("span", _hoisted_2, [
          (_ctx.hasChildren)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "inline-flex rounded-full p-2.5 hover:bg-gray-200 transition-colors",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggleExpand && _ctx.onToggleExpand(...args)), ["stop"]))
              }, [
                _createVNode(_component_ExpandIcon, {
                  color: "black",
                  expand: _ctx.isExpanded,
                  class: "w-3.5 h-3.5 min-w-3.5"
                }, null, 8, ["expand"])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "inline-block w-3.5 h-3.5" }, null, -1)
              ])))
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.option.name), 1)
      ], 4),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_CustomCheckbox, {
          checked: _ctx.isSelected,
          indeterminate: _ctx.isIndeterminate,
          "onUpdate:checked": _ctx.onToggleOption
        }, null, 8, ["checked", "indeterminate", "onUpdate:checked"])
      ])
    ], 2),
    _createVNode(_component_ExpandCollapseTransition, null, {
      default: _withCtx(() => [
        (_ctx.hasChildren && _ctx.isExpanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.option.children, (child, index) => {
                return (_openBlock(), _createBlock(_component_ContentOptionsNode, {
                  key: child.id,
                  option: child,
                  level: _ctx.level + 1,
                  "selected-ids": _ctx.selectedIds,
                  "expanded-ids": _ctx.expandedIds,
                  "indeterminate-ids": _ctx.indeterminateIds,
                  "is-last": _ctx.isLast && index === _ctx.option.children.length - 1,
                  onToggleOption: _ctx.emitToggleOption,
                  onToggleExpand: _ctx.emitToggleExpand
                }, null, 8, ["option", "level", "selected-ids", "expanded-ids", "indeterminate-ids", "is-last", "onToggleOption", "onToggleExpand"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}